import { Shadows } from "@mui/material/styles/shadows";

/**
 * Elevation scale. Low elevations stay subtle (cards are flat with a border);
 * 8 and up are real shadows so menus, popovers and dialogs lift off the page.
 */
const subtle = "0px 1px 2px 0px rgba(0, 0, 0, 0.05)";
const low =
  "0px 1px 3px 0px rgba(0, 0, 0, 0.08), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)";
const mid = "0px 4px 12px 0px rgba(0, 0, 0, 0.10)";
const menu = "0px 10px 30px 0px rgba(0, 0, 0, 0.18)";
const dialog =
  "0px 12px 40px 0px rgba(0, 0, 0, 0.28), 0px 2px 6px 0px rgba(0, 0, 0, 0.12)";

const shadowFor = (elevation: number): string => {
  if (elevation <= 1) return subtle;
  if (elevation <= 4) return low;
  if (elevation <= 7) return mid;
  if (elevation <= 15) return menu;
  return dialog;
};

const shadows = [
  "none",
  ...Array.from({ length: 24 }, (_, i) => shadowFor(i + 1)),
] as Shadows;

export default shadows;
